
import Authenticator from '../../components/Authenticator/Authenticator';
import { Pages } from '../../components/Pages/Pages';
import useSettings from '../../hooks/useSettings';
import AccommodationPage from '../../pages/AccommodationPage/AccommodationPage';
import CheckOngoingApplicationPage from '../../pages/CheckOngoingApplicationPage/CheckOngoingApplicationPage';
import CoApplicantPage from '../../pages/CoApplicantPage/CoApplicantPage';
import ConsolidationsPage from '../../pages/ConsolidationPage/ConsolidationPageNO';
import ContactDetailsPage from '../../pages/ContactDetailsPage/ContactDetailsPage';
import EmploymentPage from '../../pages/EmploymentPage/EmploymentPageNO';
import ExpensePage from '../../pages/ExpensePage/ExpensePage';
import HowToApplyPage from '../../pages/HowToApplyPage/HowToApplyPage';
import IncomePage from '../../pages/IncomePage/IncomePageNO';
import LivingConditionPage from '../../pages/LivingConditionPage/LivingConditionPage';
import PepPage from '../../pages/PepPage/PepPage';
import StatusProcessingPage from '../../pages/StatusPage/ProcessingPage/StatusProcessingPage';
import SubmitPage from '../../pages/SubmitPage/SubmitPage';
import VerifyIncomePageNO from '../../pages/VerifyIncomePage/VerifyIncomePageNO';

const SubmitApplicationWizard = () => {
    const settings = useSettings();

    return (
        <Pages>
            <HowToApplyPage />
            <ContactDetailsPage />
            <LivingConditionPage />
            <AccommodationPage />
            <EmploymentPage />
            <VerifyIncomePageNO />
            {settings.checkOngoing && (
                <Authenticator autoLogin={true}>
                    <CheckOngoingApplicationPage />
                </Authenticator>
            )}
            <Authenticator autoLogin={true}>
                <ConsolidationsPage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <IncomePage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <ExpensePage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <PepPage />
            </Authenticator>
            {settings.withCoApplicant && (
                <Authenticator autoLogin={true}>
                    <CoApplicantPage />
                </Authenticator>
            )}
            <Authenticator autoLogin={true}>
                <SubmitPage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <StatusProcessingPage />
            </Authenticator>
        </Pages>
    );
};

export default SubmitApplicationWizard;
